const logLength = 'ef203e041c724468be6911867868e7cb';
const netVolume = 'c194282f02a94345863be4a59075ddb3';
const logDiameters = 'a4211ba806234d949965f7f51022abc2';
const logDiameterAvg = 'bdf5a1b933f949d8803d3a327da8af31';
const logAmount = 'b71e38ac521e49348c7045b4cca36b25';
const logsTotal = '2917865a135542e3a90114d8a562eb88';
const joistCount = '9047c014a82c4c00976b2dd62c8fc997';
const fullMeasurement = '1bb8429f8ea44db798ac8e8f42376f73';
const frontImageCertified = '3e3a856bdd954483a7fef0965f2c9259';
const backImageCertified = '22a9f02c083d42e69b46e0493ad80a41';
const frontArea = '92960db1d5f047909aebd2c57dda4d51';
const backArea = '7fce5d2be42e4153bcee42a8fe3497ed';
const referenceArea = '70f9bb791aa3454ebfc2970ba6d57306';
const stackUUID = '48c7b958b9c745ecbf7c1a8c683d37a6';
const applicationID = 'f0332f7607fc42b189a6187d8e3c5105';
const calibrationID = 'c0dba5e2fadd459a8f09cc32d6b66db2';
const frontHeights = '2b378b636dbd4433b30622349699d1f4';
const backHeights = '9543623123594f41b051b04d6aba9ddc';
const frontInterval = '104b46ae9e0944bc875d87e9a4ebd59f';
const backInterval = 'd5b69e650f6043759cdfb8bb33134b5c';
const frontUUID = 'ea26cc107eb94c8a9e61e8f2b6281045';
const backUUID = 'a6df9e7f0f5b48c29cd86f271de6d4e5';
const frontAreaPolygonPts = '0cd786727bac4c2fbc13de14b5122aac';
const backAreaPolygonPts = 'a1b9bc2930354ae5bb14a6799164fb3c';
const stackLength = '74e66b4cd53a41aba85ac4f6247b5d88';
const locationMeasurement = '8e9b2e002fd749e088d0c86696add79f';
const totalRaummeter = 'baa7b08f307049f0a710b45f840d471e';
const manualBackArea = '0d1a20ebd46f40edbc3a4a86f17778cc';

const FieldId = {
  fullMeasurement,
  logLength,
  netVolume,
  logDiameters,
  logDiameterAvg,
  logAmount,
  logsTotal,
  joistCount,
  frontImageCertified,
  backImageCertified,
  frontArea,
  backArea,
  referenceArea,
  stackUUID,
  applicationID,
  calibrationID,
  frontHeights,
  backHeights,
  frontInterval,
  backInterval,
  frontUUID,
  backUUID,
  frontAreaPolygonPts,
  backAreaPolygonPts,
  stackLength,
  locationMeasurement,
  totalRaummeter,
  manualBackArea,
};

export default FieldId;
